import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import * as Plotly from 'plotly.js';
declare global {
  interface Window {
    Plotly: typeof Plotly;
  }
}
@Component({
  selector: 'app-double-y-axis-chart',
  templateUrl: './double-y-axis-chart.component.html',
  styleUrls: ['./double-y-axis-chart.component.css']
})
export class DoubleYAxisChartComponent implements OnInit {
  @Input() index: any = 0;
  @ViewChild("doubleY", { static: true }) private doubleY: ElementRef<any>;
  @Input() doubleYData: any;
  constructor() { }

  ngOnInit(): void { 
  }

  ngOnChanges() {
    if (this.doubleYData.length) {
      setTimeout(() => {
        this._plotGraph();
      }, 0);
    }
  }

  private _plotGraph() {

    window.Plotly.newPlot(
      this.doubleY?.nativeElement, //viewchild element
      this.doubleYData, {
      margin: {
        l: 50,
        r: 70,
        b: 20,
        t: 0
      },
      yaxis: {
        title: this.doubleYData?.[0]?.name,
        color: this.doubleYData?.[0]?.tickColor
      },
      yaxis2: {
        title: this.doubleYData?.[1]?.name,
        color: this.doubleYData?.[1]?.tickColor,
        overlaying: 'y',
        side: 'right',
        // rangemode: 'tozero', autorange: true
        range: this.doubleYData?.[1]?.autorange ? null : [0, this.doubleYData?.[1]?.upperLimit],
        autorange: this.doubleYData?.[1]?.autorange
      },
      legend: this.doubleYData?.[0]?.legend
    },
      { //this is where the configuration is defined
        responsive: true,
        displaylogo: false,
        scrollZoom: true,
        displayModeBar: false,
        // useResizeHandler: true
      });
  }

}
